<template lang="pug">
  v-card
    r-table(
      :service="service"
      :headers="headers"
      :filters="filters"
      :showButton="() => $can('VIEW_DETAIL_ACCOUNTING_SEAT')"
      :deleteButton="({acc_accounting_seat_status})=> acc_accounting_seat_status.status === 'Sin Asentar' && $can('DELETE_ACCOUNTING_SEAT')"
      @remove="submitDelete($event.item.id)"
      @detail="$router.push(`/accounting_records/${$event.item.id}`)"
      no-search-box
      no-search
      ref="refDTAccountingSeatList"
      remind-key='accounting-records-list'
      )
      template(slot='actions' slot-scope="props")
        r-btn-action(
          @click="submitPrintPDF( props.item )"
          slot="activator"
          color="info"
          tooltip='PDF'
          v-if="$can('VIEW_DETAIL_ACCOUNTING_SEAT')"
          )
          v-icon file_download
</template>

<script>
import { CrudCreateButton } from '@/components/reusable_components'
import { RBtnAction, RTable } from '@/components/reusable_components/next'
import {
    AccountingSeatDTService,
    getAllTypes,
    getAllConcepts,
    getAllStatus,
    deleteAccountingSeat,
    accountingSeatPrintPDF,
} from '../../services/api/accountingSeat'
import UserService from '@/services/api/user'
import { ListHeaders } from './headers'
import FiltersAccountingRecords from './FilterAccountingRecords'
import { mapActions, mapState } from 'vuex'
import AccAccountingSeat from '@/models/Accounting/AccAccountingSeat'
export default {
    name: 'list-vouchers',
    props: {},
    data: function() {
        return {
            service: AccAccountingSeat,
            headers: ListHeaders,
            filters: FiltersAccountingRecords,
            deleteId: 0,
            selectedItem: {},
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    methods: {
      ...mapActions('MenuesModule', {
          setTitleTopBar: 'setTitleTopBar',
      }),
      ...mapActions('SnackbarModalModule', {
          initSnackbar: 'initSnackbar',
          hideSnack: 'hideSnack',
          resetSnackbarState: 'resetSnackbarState',
          setMessageConfirmSnack: 'setMessageConfirmSnack',
      }),
      /**
       * 
       */
      submitCreate() {
        this.$router.push({ name: 'accounting-records-create' })
      },
      submitPrintPDF: function(item) {
          this.resetSnackbarState()
          this.setMessageConfirmSnack('Descargar')
          let payload = this.fillSnack(
              'info',
              '¿Descargar detalle de asiento contable?',
              ''
          )
          this.initSnackbar(payload)
          this.selectedItem = item
      },
      submitDelete: function(event) {
          this.resetSnackbarState()
          this.setMessageConfirmSnack('Eliminar')
          let payload = this.fillSnack(
              'warning',
              '¿Desea eliminar el asiento contable?',
              ''
          )
          this.initSnackbar(payload)
          this.deleteId = event
      },
      //-
      setFilterOptions(index, options) {
          this.filters[index].options = options
      },
      //-
      mapUserToFilter: ({ hr_employee, id }) => ({
          text: [
              hr_employee.names,
              hr_employee.last_name1,
              hr_employee.last_name2,
          ].join(' '),
          value: id,
      }),
      //-
      mapTypeToFilter: ({ type, id }) => ({
          text: type,
          value: id,
      }),
      //-
      mapConceptToFilter: ({ concept, id }) => ({
          text: concept,
          value: id,
      }),
      //-
      mapStatusToFilter: ({ status, id }) => ({
          text: status,
          value: id,
      }),
    },
    watch: {
        async responseConfirm(val) {
            //-
            if (val === 'Eliminar') {
                this.resetSnackbarState()
                let response = await deleteAccountingSeat(this.deleteId)
                //-
                if (response.status == 'success') {
                    let payload = this.fillSnack(
                        'success',
                        'Asiento contable eliminado correctamente',
                        ''
                    )
                    this.initSnackbar(payload)
                    this.$refs.refDTAccountingSeatList.refresh()
                } else {
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.error
                    )
                    this.initSnackbar(payload)
                }
            }
            if (val === 'Descargar') {
                this.resetSnackbarState()
                let response = await accountingSeatPrintPDF(
                    this.selectedItem.id
                )
                //- PDF associate into link
                const url = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                const link = document.createElement('a')
                link.href = url
                link.setAttribute(
                    'download',
                    `Voucher-${this.selectedItem.code}.pdf`
                )
                document.body.appendChild(link)
                link.click()

                //-
                if (response.status == 200) {
                    let payload = this.fillSnack(
                        'success',
                        'Descarga correcta',
                        ''
                    )
                    this.initSnackbar(payload)
                    this.$refs.refDTAccountingSeatList.checkAndFetch()
                } else {
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.error
                    )
                    this.initSnackbar(payload)
                }
            }
        },
    },
    components: {
        RBtnAction,
        RTable,
        'crud-create-button': CrudCreateButton,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    created: function() {
        this.setTitleTopBar('Asientos contables')
    },
    beforeMount: async function() {
        let users = await UserService.fetchAll()
        let types = await getAllTypes()
        let concepts = await getAllConcepts()
        let status = await getAllStatus()
        this.setFilterOptions(0, users.map(this.mapUserToFilter))
        this.setFilterOptions(1, types.data.map(this.mapTypeToFilter))
        this.setFilterOptions(2, concepts.data.map(this.mapConceptToFilter))
        this.setFilterOptions(3, status.data.map(this.mapStatusToFilter))
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_ACCOUNTING_SEAT')) ctx.$router.push('/')
        })
    },
    mounted() {
      this.setItems([
        {
          text: 'crear asiento contable',
          icon: 'add_circle',
          action: this.submitCreate,
        }
      ])
    },
}
</script>